import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  OutlinedInput,
} from "@mui/material";
import "./index.scss";

const DropDown = ({
  options = [],
  value = "",
  onChange,
  label,
  placeholder,
  error,
  required = false,
  disabled = false,
  fullWidth = true,
  name,
  id,
  className = "",
  ...props
}) => {
  const handleChange = (event) => {
    if (onChange) {
      const syntheticEvent = {
        target: {
          name: name || id,
          value: event.target.value,
        },
      };
      onChange(syntheticEvent);
    }
  };

  return (
    <div className={`mui-dropdown ${className}`}>
      <FormControl
        fullWidth={fullWidth}
        error={!!error}
        disabled={disabled}
        variant="outlined"
      >
        {label && (
          <InputLabel id={`${id || name}-label`} required={required} shrink>
            {label}
          </InputLabel>
        )}
        <Select
          labelId={`${id || name}-label`}
          id={id || name}
          name={name}
          value={value}
          onChange={handleChange}
          input={<OutlinedInput notched label={label} />}
          displayEmpty
          {...props}
        >
          {placeholder && <MenuItem value="">{placeholder}</MenuItem>}
          {options.map((option, idx) => (
            <MenuItem
              key={option.value !== undefined ? option.value : idx}
              value={option.value !== undefined ? option.value : option}
            >
              {option.label !== undefined ? option.label : option}
            </MenuItem>
          ))}
        </Select>
        {error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    </div>
  );
};

export default DropDown;
